function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* istanbul ignore file */

import { useEffect, useRef, useState } from 'react';
import { useScroll } from 'react-use';
import { isBreakpointLargeOrAbove, useBreakpoint } from '@noths/polaris-client-ribbons-base';
import { getNextPosition, getPreviousPosition, hasNavigation, hasNextItem, hasPreviousItem, isNextItem, isPreviousItem } from "./utils";
import { useCarouselIntersections } from "../../../../hooks/useCarouselIntersections";
export var useCarousel = function useCarousel(wrapper, elements, onNavigateCarousel) {
  var _useScroll = useScroll(wrapper),
    x = _useScroll.x,
    y = _useScroll.y;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasNext = _useState4[0],
    setNext = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasPrevious = _useState6[0],
    setPrevious = _useState6[1];
  var intersections = useCarouselIntersections(wrapper, elements);
  var breakpoint = useBreakpoint({
    initializeWithLarge: true
  });
  var isLargeScreen = isBreakpointLargeOrAbove(breakpoint);
  var onNext = function onNext() {
    var nextPosition = !!wrapper.current && getNextPosition(position, wrapper.current, intersections);
    if (nextPosition !== false) {
      setPosition(nextPosition);
    }
    onNavigateCarousel === null || onNavigateCarousel === void 0 || onNavigateCarousel({
      navigation: {
        type: 'Arrow Click',
        direction: 'Right'
      }
    });
  };
  var onPrevious = function onPrevious() {
    var previousPosition = !!wrapper.current && getPreviousPosition(position, wrapper.current, intersections);
    if (previousPosition !== false) {
      setPosition(previousPosition);
    }
    onNavigateCarousel === null || onNavigateCarousel === void 0 || onNavigateCarousel({
      navigation: {
        type: 'Arrow Click',
        direction: 'Left'
      }
    });
  };
  var onFocus = function onFocus(element) {
    if (isNextItem(intersections, element)) {
      onNext();
    }
    if (isPreviousItem(intersections, element)) {
      onPrevious();
    }
  };
  useEffect(function () {
    setNext(hasNextItem(intersections));
    setPrevious(hasPreviousItem(intersections));
  }, [hasNextItem, hasPreviousItem, intersections]);

  // reset scroll position when moving between breakpoints
  useEffect(function () {
    if (isLargeScreen && wrapper.current) {
      wrapper.current.scrollLeft = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLargeScreen, wrapper.current && wrapper.current.scrollLeft]);
  var touchXposition = useRef(0);

  // Calculate touch drag direction
  useEffect(function () {
    var carouselWrapper = wrapper.current;
    var touchStartListener = function touchStartListener(e) {
      touchXposition.current = e.changedTouches[0].clientX;
    };
    var touchEndListener = function touchEndListener(e) {
      var direction = e.changedTouches[0].clientX > touchXposition.current ? 'Left' : 'Right';
      onNavigateCarousel === null || onNavigateCarousel === void 0 || onNavigateCarousel({
        navigation: {
          type: 'Scroll',
          direction
        }
      });
    };
    var listenerOptions = {
      passive: true
    };
    carouselWrapper === null || carouselWrapper === void 0 || carouselWrapper.addEventListener('touchstart', touchStartListener, listenerOptions);
    carouselWrapper === null || carouselWrapper === void 0 || carouselWrapper.addEventListener('touchend', touchEndListener, listenerOptions);
    return function () {
      carouselWrapper === null || carouselWrapper === void 0 || carouselWrapper.removeEventListener('touchstart', touchStartListener, listenerOptions);
      carouselWrapper === null || carouselWrapper === void 0 || carouselWrapper.removeEventListener('touchend', touchEndListener, listenerOptions);
    };
  }, [onNavigateCarousel, wrapper]);
  return {
    position: isLargeScreen ? position : 0,
    onNext,
    onPrevious,
    onFocus,
    hasNext,
    hasPrevious,
    hasNavigation: hasNavigation(intersections),
    xPosition: x,
    yPosition: y
  };
};